import { render } from "./RequestFilesModal.vue?vue&type=template&id=3e03066a&scoped=true"
import script from "./RequestFilesModal.vue?vue&type=script&lang=js"
export * from "./RequestFilesModal.vue?vue&type=script&lang=js"

import "./RequestFilesModal.vue?vue&type=style&index=0&id=3e03066a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e03066a"]])

export default __exports__